import { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles, useMediaQuery } from '@ellucian/react-design-system/core';
import { useTheme } from '@mui/material';
import useApplicationForm from './useApplicationForm';
import { fontFamilyDefault, spacing30, spacing50 } from '@ellucian/react-design-system/core/styles/tokens';
import { replacePlaceholders } from '../Helpers/replacePlaceholders';
import { useSelector } from 'react-redux';
import ethosModels from '@nsr/applicant-apply-shared/src/constants/ethosModels';
import { useApi } from '../ApiContext/ApiContext';
import { SimpleDialog } from '@ellucian/react-design-system/core';
import HtmlFormattedMessage from '../HtmlFormattedMessage/HtmlFormattedMessage';

const useStyles = makeStyles({
    name: 'SubmittedDialog'
})(() => ({
    root: {
        display: 'grid',
        gridAutoRows: 'min-content',
        gridGap: spacing50,
    },
    content: {
        fontFamily: fontFamilyDefault,
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
    },
    dialogPaper: {
        maxWidth: '800px',
        width: '800px',
    },
    dialogTitle: {
        position: 'absolute',
        right: 20,
        top: 16
    },
    dialogContent: {
        padding: spacing30,
    },
    dialogActions: {
        position: 'absolute',
        right: 20,
        bottom: 40
    },
}));

const selectApplicationValues = state => state.application.values;

const SubmittedDialog = ({ isOpen, onClose }) => {
    const intl = useIntl();
    const { formatMessage } = intl;
    const { classes } = useStyles();
    const appValues = useSelector(selectApplicationValues);
    const api = useApi();
    const { template, adminTenant } = useApplicationForm();
    const globalSettings = window.PRELOADED_STATE?.globalSettings || adminTenant;
    const { supportedGraphqlModels } = globalSettings;


    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const handleClose = useCallback(() => onClose(), [onClose]);
    const [htmlText, setHtmlText] = useState('');

    useEffect(() => {
        const contentText = formatMessage({ id: template?.settings?.confirmationDescriptionId }) || '';
        const getText = async () => {
            const fetchedHtmlText = await replacePlaceholders(decodeURI(contentText), appValues, template, ethosModels.application.name, supportedGraphqlModels, api);
            setHtmlText(fetchedHtmlText);
        };
        getText();
    }, [template?.settings?.confirmationDescriptionId, intl]);

    return (
        <SimpleDialog
            buttonConfig={[
                {
                    id: 'ok',
                    title: formatMessage({ id: 'dialogOk' })
                },
            ]}
            title=""
            open={isOpen}
            closeOnClickOut={false}
            handleButtonClick={handleClose}
            showTitleBarClose={true}
            onClose={handleClose}
            fullScreen={isMobile}
            PaperProps={{ className: classes.dialogPaper }}
            DialogTitleProps={{ className: classes.dialogTitle }}
            DialogContentProps={{ className: classes.dialogContent }}
            DialogActionsProps={{ className: classes.dialogActions }}
        >
            <div className={classes.content}>
                <HtmlFormattedMessage htmlString={htmlText} normalizeSpaces/>
            </div>
        </SimpleDialog>
    );
};

export default SubmittedDialog;
